import { AuthContextType } from '@auth/AuthProvider';
import NetworkController, { HTTPMethod, HTTPRequest, HTTPResponse } from '@data/controller/NetworkController';
import { Category } from '@data/ChurchDataProvider';

export default class CategoryController {
  private static baseURL: string = process.env.REACT_APP_SANCTUARY_API_URL || "";

  static async createCategory(
    churchID: string,
    name: string,
    auth: AuthContextType
  ): Promise<HTTPResponse<Category>> {
    return await NetworkController.performRequestAt<Category>(
      this.baseURL,
      new HTTPRequest(HTTPMethod.POST, `/v1/church/${churchID}/category`, {
        name
      }),
      auth.consumeRefreshToken
    );
  }

  static async updateCategory(
    churchID: string,
    categoryID: string,
    name: string,
    auth: AuthContextType
  ): Promise<HTTPResponse<Category>> {
    return await NetworkController.performRequestAt<Category>(
      this.baseURL,
      new HTTPRequest(HTTPMethod.PATCH, `/v1/church/${churchID}/category/${categoryID}`, {
        name
      }),
      auth.consumeRefreshToken
    );
  }

  static async deleteCategory(
    churchID: string,
    categoryID: string,
    auth: AuthContextType
  ): Promise<HTTPResponse<void>> {
    return await NetworkController.performRequestAt<void>(
      this.baseURL,
      new HTTPRequest(HTTPMethod.DELETE, `/v1/church/${churchID}/category/${categoryID}`),
      auth.consumeRefreshToken
    );
  }
}
